module.exports = "<section class=\"gw-dot-indicators\">\n    <div ng-repeat=\"step in stepValidityFns track by $index\">\n        <p class=\"gw-indicator-dot\" ng-click=\"transition($index)\"\n           ng-class=\"[customClasses[$index],{'gw-complete': step.isValid(),'gw-invalid': form.submitted && !step.isValid(), 'gw-active': currentStep===$index}]\"\n        >\n        </p>\n    </div>\n</section>"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/quoteandbind/quickquote/common/directives/templates/quick-step-progress.html
 ** module id = 854
 ** module chunks = 0
 **/